import React from "react";
import { Button } from "../components/ui/button";
import Logobgtransparentblack from '../images/DA_NoxZi/Logo-bg-transparent-black.png';
import Logobgblacktwhiterotate from '../images/DA_NoxZi/Logo-bg-black-twhite-rotate.png';
import logoSvgUpResult from '../images/up-result.svg';
import logoSvgUiProof from '../images/ui-proof.svg';
import logoSvgPhoneBento from '../images/phone-bento.svg';
import svgArrowBtn from '../images/arrow-btn.svg';
import homescreentest from '../images/home-page-test.png';
import bgHero from '../images/bg-hero.png';
import portrait from '../images/portrait.jpeg';
import { Link } from "react-router-dom";
import Footer from "../components/layout/Footer";
import NavBar from "../components/layout/NavBar";

export default function LandingPage() {
  return (
    <div className="relative min-h-screen text-black overflow-hidden bg-white selection:bg-black selection:text-white">

      {/* Image de fond hero */}
      <div className="absolute inset-0 z-0 h-[100vh]">
        <img src={bgHero} alt="Background" className="w-full h-full object-cover pt-20" />
      </div>

      <NavBar />

      {/* ── HERO ──────────────────────────────────────────────────── */}
      <section className="relative text-center pt-20 px-6 py-12 md:py-24 z-10">
        <div className="mb-6 flex items-center justify-center">
          <div className="rounded-full border border-black/10 bg-white/70 px-4 py-2 backdrop-blur-md shadow-[0_6px_20px_rgba(0,0,0,0.05)]">
            <p className="font-asap text-[12px] uppercase tracking-[0.28em] text-[#b98c42]">
              Applications mobiles sur mesure
            </p>
          </div>
        </div>

        <h1 className="text-2xl leading-[54px] font-asap md:text-4xl font-medium max-w-3xl mx-auto">
          Parce que chaque{" "}
          <img src={Logobgblacktwhiterotate} alt="Logo" className="inline-block w-16 h-16 align-middle" />{" "}
          vision est unique,
          <br className="hidden md:block" />
          chaque application devrait l'être aussi
        </h1>

        <p className="mt-4 text-[#000000B2] max-w-xl mx-auto font-asap">
          Votre ambition mérite une solution sur mesure. Nous créons l'application
          qui vous ressemble, portée par notre savoir-faire.
        </p>

        {/* Deux boutons côte à côte */}
        <div className="mt-6 flex items-center justify-center gap-4 flex-wrap">
          <a
            href="mailto:contact@noxzi.com"
            className="font-asap bg-black text-white px-6 py-2.5 rounded-full shadow-[0_9px_10px_rgba(0,0,0,0.25),_inset_0_2px_7.3px_#ffffff] hover:scale-[1.05] transition-transform inline-flex items-center"
          >
            Découvrir les services
          </a>
          <a
            href="https://cal.com/noxzi/30min"
            className="font-asap border border-black/20 text-black px-6 py-2.5 rounded-full hover:bg-black hover:text-white transition-all inline-flex items-center gap-2"
          >
            Réserver un appel
            <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4" />
          </a>
        </div>

        {/* Phone mockup */}
        <div className="mt-32 flex justify-center relative">
          <img
            src={homescreentest}
            alt="Mobile app preview"
            className="w-4xl md:w-4xl rounded-2xl z-10"
          />
          <div className="absolute left-0 right-0 top-0 bottom-0 flex justify-center opacity-30 blur-sm z-0">
            <img src={homescreentest} alt="" className="w-72 md:w-96" />
          </div>
        </div>
      </section>

      {/* Gradient fade overlay */}
      <div className="absolute top-[64vh] left-0 w-full h-96 bg-[linear-gradient(180deg,rgba(255,255,255,0)_4.41%,#fff_76.1%)] mix-blend-lighten z-20 pointer-events-none" />

      {/* ── INTRO APPLICATION MOBILE ──────────────────────────────── */}
      <div className="text-left pt-12 px-6 relative z-10">
        <h2 className="font-asap text-5xl md:text-6xl font-[600] mb-6 text-gray-900 max-w-4xl mx-auto">
          Application mobile
        </h2>
        <p className="text-lg md:text-xl text-gray-600 mb-4 max-w-4xl mx-auto leading-relaxed">
          Nous concevons des applications mobiles performantes, robustes et évolutives grâce à React Native.
          Ce framework cross-platform nous permet de développer une seule base de code pour iOS et Android,
          réduisant les coûts tout en garantissant une qualité native et une expérience utilisateur fluide.
          Nos apps sont pensées pour s'adapter à vos besoins métiers, vos objectifs et les usages réels de vos utilisateurs.
          Du prototypage à la publication sur les stores, nous vous accompagnons à chaque étape du projet.
        </p>
      </div>

      {/* ── BENTO GRID ────────────────────────────────────────────── */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

            {/* Colonne gauche */}
            <div className="bg-[#F3F3F3] rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col justify-between items-center text-center">
              <div className="z-20">
                <h2 className="text-3xl font-[500] font-asap mb-2">
                  Et si on donnait vie à votre application, ensemble ?
                </h2>
                <p className="text-gray-600 leading-relaxed mt-4">
                  Une approche collaborative, de l'idée initiale jusqu'à la mise en ligne sur les stores.
                </p>
              </div>
              <div className="w-full flex justify-center items-end z-10">
                <img src={logoSvgPhoneBento} alt="Phone bento" className="object-contain w-[90%]" />
              </div>
            </div>

            {/* Colonne droite — deux cards */}
            <div className="grid grid-rows-2 gap-6">

              <div className="bg-[#F3F3F3] rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 relative overflow-hidden">
                <div className="h-48 mb-6 flex items-center justify-center relative">
                  <div className="relative flex items-end justify-center h-48 -mb-12">
                    <img src={logoSvgUpResult} alt="Résultats" className="h-44 object-contain z-10" />
                  </div>
                </div>
                <div className="font-asap bg-white p-4" style={{ boxShadow: 'inset 0px -10px 25px -3px rgba(0,0,0,0.15)' }}>
                  <h2 className="text-2xl font-[500] mb-4 text-gray-900">Conçues pour performer</h2>
                  <p className="text-gray-600 leading-relaxed">
                    Parce que vos besoins sont uniques, nos choix techniques visent des applications efficaces, rapides et durables.
                  </p>
                </div>
              </div>

              <div className="bg-[#F3F3F3] rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 relative overflow-hidden">
                <div className="h-48 mb-6 flex items-center justify-center relative">
                  <div className="relative flex items-end justify-center h-60">
                    <img src={logoSvgUiProof} alt="UI Design" className="h-54 object-contain z-10" />
                  </div>
                </div>
                <div className="font-asap bg-white p-4" style={{ boxShadow: 'inset 0px -10px 25px -3px rgba(0,0,0,0.15)' }}>
                  <h2 className="text-2xl font-[500] mb-4 text-gray-900">Un design pensé à 360°</h2>
                  <p className="text-gray-600 leading-relaxed">
                    Nous concevons des interfaces complètes et cohérentes, pensées pour refléter votre identité et offrir une expérience fluide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-right max-w-4xl mx-auto">
          <a
            href="https://cal.com/noxzi/30min"
            className="mt-6 inline-flex font-asap bg-black text-white px-6 py-2.5 rounded-full shadow-[0_9px_10px_rgba(0,0,0,0.25),_inset_0_2px_7.3px_#ffffff] hover:scale-[1.05] transition-transform"
          >
            Commencer mon projet
          </a>
        </div>
      </section>

      {/* ── ACCOMPAGNEMENT HUMAIN ─────────────────────────────────── */}
      <section className="max-w-7xl mx-auto px-6 py-24 grid gap-12 md:grid-cols-2 items-center">
        <div className="relative w-full max-w-md mx-auto group">
          {/* Carte arrière */}
          <div className="absolute top-3 left-3 w-full h-full rounded-2xl bg-white shadow-md rotate-3 transition-all duration-300 ease-in-out group-hover:rotate-0 z-0 group-hover:top-0 group-hover:left-0" />
          {/* Carte principale */}
          <div className="relative z-10 overflow-hidden rounded-2xl -rotate-3 hover:rotate-0 transition-all duration-300 ease-in-out shadow-[0_9px_10px_rgba(0,0,0,0.25),inset_0_2px_7.3px_#ffffff]">
            <img src={portrait} alt="Notre équipe" className="w-full h-[70vh] object-cover rounded-2xl" />
            <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-white to-transparent px-4 py-3 flex items-end">
              <p className="text-sm font-asap text-black font-medium">Un accompagnement humain</p>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
              Notre approche
          </p>
          <h2 className="text-3xl font-semibold font-asap">
            Un accompagnement humain, du premier échange jusqu'à la mise en ligne.
          </h2>
          <p className="text-gray-600 leading-relaxed font-asap">
            Chez nous, chaque projet commence par une écoute attentive.<br />
            Nous vous conseillons à chaque étape : design, développement, choix techniques, et évolutions futures.<br />
            Notre équipe reste disponible, réactive, et impliquée — parce qu'au-delà du produit, c'est la relation qui fait la différence.
          </p>
          <a
            href="https://cal.com/noxzi/30min"
            className="inline-flex font-asap bg-black text-white px-6 py-2.5 rounded-full shadow-[0_9px_10px_rgba(0,0,0,0.25),_inset_0_2px_7.3px_#ffffff] hover:scale-[1.05] transition-transform"
          >
            Parler de mon projet
          </a>
        </div>
      </section>

      {/* ── PROJETS ───────────────────────────────────────────────── */}
      <section className="relative px-6 py-36 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[70%] h-px bg-gradient-to-r from-transparent via-[#c9a35f]/20 to-transparent" />
          <div className="absolute inset-0 opacity-[0.025] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
          <div className="absolute top-12 right-[8%] w-72 h-72 rounded-full bg-[#c9a35f]/[0.06] blur-3xl" />
        </div>

        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center mb-20">
            <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
              Nos projets
            </p>
            <h2 className="text-[2.8rem] md:text-[5.2rem] leading-[0.95] tracking-[-0.075em] font-[600] font-asap text-black max-w-5xl mx-auto">
              Des projets pensés,
              <br className="hidden md:block" />
              conçus et mis en ligne avec exigence
            </h2>
            <p className="mt-7 text-[17px] md:text-[20px] text-black/60 max-w-3xl mx-auto font-asap leading-relaxed">
              Chaque projet que nous réalisons répond à un besoin réel, avec une attention
              particulière portée au design, à la cohérence produit et à la qualité d'exécution.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                title: "PACTE",
                subtitle: "Application mobile",
                text: "Une application pensée pour dynamiser le commerce local, avec fidélité, messagerie, actualités et expérience utilisateur complète."
              },
              {
                title: "Savoinimaux",
                subtitle: "Site web",
                text: "Une refonte plus moderne, plus claire et plus professionnelle pour mieux représenter l'association et valoriser son image."
              },
              {
                title: "AJ Construction",
                subtitle: "Présence digitale",
                text: "Un travail orienté visibilité, image et performance locale pour renforcer la présence en ligne et soutenir le développement."
              }
            ].map((project) => (
              <div
                key={project.title}
                className="group relative overflow-hidden rounded-[34px] border border-black/[0.06] bg-white p-8 shadow-[0_12px_30px_rgba(0,0,0,0.035)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_70px_rgba(0,0,0,0.08)]"
              >
                <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(201,163,95,0.08),transparent_55%)] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#c9a35f]/25 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <div className="relative z-10">
                  <p className="font-asap uppercase tracking-[0.24em] text-[10px] text-[#b98c42] mb-4">
                    {project.subtitle}
                  </p>
                  <h3 className="text-[30px] leading-[1.02] tracking-[-0.05em] font-asap font-[500] text-black mb-4">
                    {project.title}
                  </h3>
                  <p className="text-black/60 font-asap leading-relaxed text-[15.5px] mb-8">
                    {project.text}
                  </p>
                  <a href="#" className="inline-flex items-center gap-2 text-black font-asap text-[14px] hover:text-[#9a7130] transition-colors">
                    Voir le projet
                    <span className="text-[#b98c42]">→</span>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── EXPERTISES ────────────────────────────────────────────── */}
      <section className="relative px-6 py-36 bg-[linear-gradient(180deg,#fbfbfb_0%,#f3f3f3_100%)] overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
          <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#c9a35f]/20 to-transparent" />
          <div className="absolute bottom-10 left-[10%] w-72 h-72 rounded-full bg-black/[0.025] blur-3xl" />
        </div>

        <div className="max-w-6xl mx-auto relative z-10 grid lg:grid-cols-[0.95fr_1.05fr] gap-14 items-center">
          {/* Dark card */}
          <div className="relative">
            <div className="absolute -inset-6 rounded-[46px] bg-gradient-to-b from-[#c9a35f]/10 to-transparent blur-2xl opacity-70" />
            <div className="relative overflow-hidden rounded-[40px] border border-white/10 bg-black px-8 py-10 md:px-10 md:py-12 shadow-[0_35px_110px_rgba(0,0,0,0.22)]">
              <div className="absolute inset-0 opacity-[0.08]">
                <img src={bgHero} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="absolute inset-0 opacity-[0.035] [background-image:radial-gradient(#fff_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.22),transparent_28%)]" />
              <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#c9a35f]/45 to-transparent" />
              <div className="relative z-10">
                <p className="font-asap uppercase tracking-[0.28em] text-[10px] text-[#d1a75f] mb-4">
                  Ce que nous concevons
                </p>
                <h3 className="text-[2rem] md:text-[2.8rem] leading-[0.98] tracking-[-0.06em] font-asap font-[500] text-white mb-5">
                  Applications mobiles, sites web et expériences digitales
                </h3>
                <p className="text-white/70 font-asap leading-relaxed text-[16px] md:text-[18px]">
                  Nous créons des produits digitaux complets, pensés pour être beaux,
                  utiles, cohérents et alignés avec vos objectifs de marque, de visibilité
                  et de performance.
                </p>
              </div>
            </div>
          </div>

          {/* Tags */}
          <div>
            <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
              Nos expertises
            </p>
            <h2 className="text-[2.8rem] md:text-[5.1rem] leading-[0.95] tracking-[-0.075em] font-[600] font-asap text-black mb-7">
              Bien plus qu'une simple application
            </h2>
            <p className="text-[17px] md:text-[20px] text-black/60 font-asap leading-relaxed mb-10 max-w-2xl">
              Selon vos besoins, nous pouvons concevoir une application mobile,
              un site web, une interface d'administration, une identité digitale
              ou un écosystème complet pensé pour évoluer dans le temps.
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              {[
                "Applications mobiles iOS & Android",
                "Sites web modernes et sur mesure",
                "UI / UX Design",
                "Interfaces d'administration",
                "Identité visuelle digitale",
                "Accompagnement produit"
              ].map((item) => (
                <div
                  key={item}
                  className="rounded-[22px] border border-black/[0.06] bg-white/95 px-5 py-4 font-asap text-black shadow-[0_6px_18px_rgba(0,0,0,0.03)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_14px_34px_rgba(0,0,0,0.06)]"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── PROCESSUS ─────────────────────────────────────────────── */}
      <section className="relative px-6 py-36 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[72%] h-px bg-gradient-to-r from-transparent via-[#c9a35f]/20 to-transparent" />
          <div className="absolute inset-0 opacity-[0.035] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
          <div className="absolute top-20 left-[9%] w-72 h-72 rounded-full bg-[#c9a35f]/[0.07] blur-3xl" />
          <div className="absolute bottom-0 right-[8%] w-80 h-80 rounded-full bg-black/[0.03] blur-3xl" />
        </div>

        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center mb-20">
            <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
              Notre méthode
            </p>
            <h2 className="text-[2.8rem] md:text-[5.4rem] leading-[0.95] tracking-[-0.075em] font-[600] font-asap text-black max-w-5xl mx-auto">
              Une méthode de travail
              <br className="hidden md:block" />
              claire, exigeante et maîtrisée
            </h2>
            <p className="mt-7 text-[17px] md:text-[21px] text-black/60 max-w-3xl mx-auto font-asap leading-relaxed">
              Chaque projet suit une trajectoire précise pour transformer une idée
              en une application cohérente, performante et pensée pour durer.
            </p>
          </div>

          <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6">
            {[
              { step: "01", title: "Échange & cadrage", text: "Nous analysons votre besoin, votre cible, vos enjeux et la direction produit à construire." },
              { step: "02", title: "Design & prototype", text: "Nous donnons forme à l'expérience avec une interface claire, élégante et fidèle à votre image." },
              { step: "03", title: "Développement", text: "Nous réalisons une base technique propre, robuste et évolutive pour un produit fiable." },
              { step: "04", title: "Lancement & suivi", text: "Nous vous accompagnons jusqu'à la mise en ligne, puis dans les évolutions futures du projet." }
            ].map((item, index) => (
              <div
                key={item.step}
                className="group relative min-h-[320px] overflow-hidden rounded-[34px] border border-black/[0.06] bg-[linear-gradient(180deg,#ffffff_0%,#f7f7f7_100%)] p-7 shadow-[0_10px_32px_rgba(0,0,0,0.035)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_70px_rgba(0,0,0,0.08)]"
              >
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(201,163,95,0.10),transparent_34%)] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#c9a35f]/25 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

                <div className="relative z-10 h-full flex flex-col">
                  <div className="flex items-start justify-between mb-10">
                    <span className="text-[64px] leading-none tracking-[-0.08em] font-[600] font-asap text-black/10">
                      {item.step}
                    </span>
                    <span className="text-[11px] tracking-[0.22em] uppercase text-[#b98c42]/75 font-asap mt-2">
                      0{index + 1}
                    </span>
                  </div>
                  <h3 className="text-[28px] leading-[1.02] tracking-[-0.05em] font-asap font-[500] text-black mb-4">
                    {item.title}
                  </h3>
                  <p className="text-black/60 font-asap leading-relaxed text-[15.5px]">
                    {item.text}
                  </p>
                  <div className="mt-auto pt-10">
                    <div className="h-px w-full bg-gradient-to-r from-[#c9a35f]/25 via-black/5 to-transparent" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TECHNOLOGIE ───────────────────────────────────────────── */}
      <section className="relative px-6 py-36 bg-[linear-gradient(180deg,#fbfbfb_0%,#f2f2f2_100%)] overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
          <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#c9a35f]/20 to-transparent" />
          <div className="absolute top-16 right-[8%] w-80 h-80 rounded-full bg-[#c9a35f]/[0.08] blur-3xl" />
          <div className="absolute bottom-16 left-[10%] w-72 h-72 rounded-full bg-black/[0.025] blur-3xl" />
        </div>

        <div className="max-w-6xl mx-auto grid lg:grid-cols-[1.05fr_0.95fr] gap-14 items-center relative z-10">
          <div>
            <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
              Technologie
            </p>
            <h2 className="text-[2.8rem] md:text-[5.3rem] leading-[0.95] tracking-[-0.075em] font-[600] font-asap text-black mb-7">
              Une stack moderne,
              <br className="hidden md:block" />
              pensée pour durer
            </h2>
            <p className="text-[17px] md:text-[20px] text-black/60 font-asap leading-relaxed mb-10 max-w-2xl">
              Nous sélectionnons des technologies fiables, maintenables et adaptées
              à vos enjeux. L'objectif n'est pas seulement de créer une belle interface,
              mais de construire un produit solide, capable d'évoluer avec votre activité.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {[
                "React Native",
                "iOS & Android",
                "Firebase",
                "UI/UX Design",
                "API & Back-end",
                "Déploiement Stores"
              ].map((tech) => (
                <div
                  key={tech}
                  className="group rounded-[22px] border border-black/[0.06] bg-white/95 px-5 py-4 text-center font-asap text-black shadow-[0_6px_18px_rgba(0,0,0,0.03)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_14px_34px_rgba(0,0,0,0.06)]"
                >
                  <span className="opacity-90 transition-all duration-300 group-hover:text-[#9a7130]">
                    {tech}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Dark card tech */}
          <div className="relative">
            <div className="absolute -inset-6 rounded-[46px] bg-gradient-to-b from-[#c9a35f]/15 to-transparent blur-2xl opacity-70" />
            <div className="relative overflow-hidden rounded-[40px] border border-white/10 bg-black px-8 py-10 md:px-10 md:py-12 shadow-[0_35px_110px_rgba(0,0,0,0.22)] transition-all duration-500 hover:-translate-y-1">
              <div className="absolute inset-0 opacity-[0.08]">
                <img src={bgHero} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="absolute inset-0 opacity-[0.035] [background-image:radial-gradient(#fff_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.22),transparent_28%)]" />
              <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#c9a35f]/45 to-transparent" />

              <div className="relative z-10">
                <div className="flex items-center gap-4 mb-8">
                  <div className="w-20 h-20 rounded-[24px] border border-white/10 bg-white/[0.05] flex items-center justify-center">
                    <img src={Logobgtransparentblack} alt="NoxZi" className="w-11 h-11 object-contain invert" />
                  </div>
                  <div>
                    <p className="text-[#d1a75f] uppercase tracking-[0.28em] text-[10px] font-asap mb-2">Infrastructure</p>
                    <div className="h-px w-24 bg-gradient-to-r from-[#c9a35f]/60 to-transparent" />
                  </div>
                </div>
                <h3 className="text-[2rem] md:text-[2.8rem] leading-[0.98] tracking-[-0.06em] font-asap font-[500] text-white mb-5 max-w-xl">
                  Des choix techniques conçus pour soutenir votre croissance
                </h3>
                <p className="text-white/70 font-asap leading-relaxed mb-9 text-[16px] md:text-[18px] max-w-xl">
                  Performance, maintenabilité, évolutivité et qualité d'exécution :
                  chaque décision technique est prise pour garantir une application
                  fiable aujourd'hui, et encore pertinente demain.
                </p>
                <a
                  href="https://cal.com/noxzi/30min"
                  className="inline-flex items-center gap-3 rounded-full bg-white text-black px-6 py-3.5 font-asap font-medium transition-all duration-300 hover:scale-[1.04]"
                >
                  Échanger sur votre besoin
                  <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── POURQUOI NOUS (version unique consolidée) ─────────────── */}
      <section className="relative px-6 py-36 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[65%] h-px bg-gradient-to-r from-transparent via-[#c9a35f]/20 to-transparent" />
          <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:19px_19px]" />
          <div className="absolute bottom-10 right-[10%] w-72 h-72 rounded-full bg-[#c9a35f]/[0.06] blur-3xl" />
        </div>

        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center mb-20">
            <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
              Pourquoi nous
            </p>
            <h2 className="text-[2.8rem] md:text-[5.3rem] leading-[0.95] tracking-[-0.075em] font-[600] font-asap text-black max-w-5xl mx-auto">
              Plus qu'un prestataire,
              <br className="hidden md:block" />
              un véritable partenaire produit
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                index: "01",
                title: "Vision produit",
                text: "Nous ne développons pas uniquement des écrans. Nous construisons une solution cohérente, utile et pensée pour les usages réels."
              },
              {
                index: "02",
                title: "Exigence design",
                text: "Chaque interface est travaillée avec précision pour offrir un rendu premium, lisible et fidèle à votre identité."
              },
              {
                index: "03",
                title: "Accompagnement réel",
                text: "Nous restons présents avant, pendant et après le lancement pour faire évoluer votre application avec cohérence."
              }
            ].map((item) => (
              <div
                key={item.title}
                className="group relative overflow-hidden rounded-[36px] border border-black/[0.06] bg-white p-8 md:p-9 shadow-[0_10px_28px_rgba(0,0,0,0.035)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_22px_60px_rgba(0,0,0,0.08)]"
              >
                <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(201,163,95,0.08),transparent_55%)] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#c9a35f]/25 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <div className="relative z-10">
                  <div className="mb-7 flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full border border-black/[0.08] bg-[#f8f8f8] flex items-center justify-center text-[12px] tracking-[0.16em] font-asap font-[600] text-[#b98c42]">
                      {item.index}
                    </div>
                    <div className="h-px flex-1 bg-gradient-to-r from-[#c9a35f]/25 to-transparent" />
                  </div>
                  <h3 className="text-[30px] leading-[1.02] tracking-[-0.05em] font-asap font-[500] text-black mb-4">
                    {item.title}
                  </h3>
                  <p className="text-black/60 font-asap leading-relaxed text-[15.5px]">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA FINAL (version unique consolidée) ─────────────────── */}
      <section className="px-6 pb-36">
        <div className="max-w-6xl mx-auto">
          <div className="relative overflow-hidden rounded-[48px] bg-black text-white px-8 py-16 md:px-14 md:py-24 shadow-[0_40px_120px_rgba(0,0,0,0.22)]">
            <div className="absolute inset-0 opacity-[0.10]">
              <img src={bgHero} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="absolute inset-0 opacity-[0.035] [background-image:radial-gradient(#fff_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.16),transparent_26%)]" />
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#c9a35f]/45 to-transparent" />
            <div className="absolute -top-24 right-0 w-72 h-72 rounded-full bg-[#c9a35f]/[0.12] blur-3xl" />
            <div className="absolute -bottom-24 left-0 w-72 h-72 rounded-full bg-white/10 blur-3xl" />


              <div className="max-w-4xl">
                <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#d1a75f] mb-5">
                  Prêt à démarrer ?
                </p>
                <h2 className="text-[2.9rem] md:text-[5.6rem] leading-[1.04] tracking-[-0.03em] font-[600] font-asap mb-6">
                  Donnons forme à votre prochain projet digital
                </h2>
                <p className="text-white/70 text-[17px] md:text-[20px] font-asap leading-relaxed max-w-2xl">
                  Application mobile, site web ou produit digital plus complet :
                  nous concevons des expériences solides, élégantes et pensées pour durer.
                </p>
              </div>

             <div className="flex flex-col sm:flex-row gap-4 mt-10">
                <a
                  href="https://cal.com/noxzi/30min"
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-white text-black px-7 py-3.5 font-asap font-medium transition-all duration-300 hover:scale-[1.04]"
                >
                  Réserver un appel
                  <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4" />
                </a>
                <a
                  href="mailto:contact@noxzi.com"
                  className="inline-flex items-center justify-center rounded-full border border-white/[0.18] px-7 py-3.5 font-asap font-medium text-white transition-all duration-300 hover:bg-white hover:text-black"
                >
                  Nous contacter
                </a>
              </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}